export default {
  init() {
    // Initialise Gallery Slick Slider Start
    jQuery('.slider-gallery').slick({
      slidesToShow: 1,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 4000,
      slidesToScroll: 1,
      swipeToSlide: true,
      dots: false,
      focusOnSelect: false,
      pauseOnFocus: false,
      infinite: true,
      asNavFor: '.slider-gallery-thumbs',
      prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Next</span></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    });
    // Initialise Gallery Slick Slider End

    // Initialise Thumbnail Slick Slider Start
    jQuery('.slider-gallery-thumbs').slick({
      slidesToShow: 4,
      centerMode: false,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToScroll: 1,
      swipeToSlide: true,
      arrows: false,
      dots: false,
      focusOnSelect: true,
      pauseOnFocus: false,
      infinite: true,
      asNavFor: '.slider-gallery',
    });
    // Initialise Thumbnail Slick Slider End

    // Initialise Thumbnail Slick Slider Start
    jQuery('.slider-products').slick({
      slidesToShow: 6,
      centerMode: false,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToScroll: 1,
      swipeToSlide: true,
      arrows: true,
      dots: false,
      focusOnSelect: false,
      pauseOnFocus: false,
      infinite: true,
      prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Next</span></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
            dots: false,
            centerMode: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            dots: false,
            centerMode: false,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            dots: false,
            centerMode: true,
          },
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 1,
            dots: false,
            centerMode: true,
          },
        },
      ],
    });
    // Initialise Thumbnail Slick Slider End
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/tax-brands.js